export default __webpack_public_path__ + "static/media/kids-dentist-consutory.e2a1fe7e.png";